import { useQuery } from "@tanstack/react-query";
import { videoGet } from "common/api/sakusas/sakusas_video";
import { QUERY_KEYS } from "constant/react_query";

export const useSakusasVideoGet = (id: string) => {
  const { data: video } = useQuery(
    [QUERY_KEYS.SAKUSAS_VIDEO_GET, id],
    async () => {
      const result = await videoGet(id);
      return result;
    },
    { staleTime: Infinity }
  );
  const result = typeof video !== "undefined" && video !== "" ? video : null;
  return result;
};
